import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

const slides = [
  `${process.env.PUBLIC_URL}/assets/slider/lmp-new-banner-1.jpg`,
  `${process.env.PUBLIC_URL}/assets/slider/lmp-new-banner-2.jpg`,
  `${process.env.PUBLIC_URL}/assets/slider/lmp-bangalore-slider.jpg`,
  `${process.env.PUBLIC_URL}/assets/slider/slider-2026-1.jpg`,
  `${process.env.PUBLIC_URL}/assets/slider/lmp-slider-1.jpg`,
];

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // Auto slider
  useEffect(() => {
    if (isPaused) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [isPaused]);

  return (
    <section className="hero-section relative overflow-hidden">
      <div
        className="relative h-[500px] bg-cover bg-center transition-all duration-700 content-center"
        style={{
          backgroundImage: `url(${slides[current]})`,
        }}
      >
        {/* Black overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Content */}
        <div className="relative md:px-0 px-5 z-10">
          <h1 className="text-white md:text-6xl text-2xl font-semibold">
            LEAN MANUFACTURING <br />PRACTICES PROGRAM
          </h1>
          <p className="pt-5 md:text-2xl md:font-bold text-[#31c991]">
            Mizuho India Japan Study Centre @ IIMB
          </p>

          <div className="flex w-full pt-5 mt-5 justify-center gap-4">
            <Link to="/mijsc-programs"><div className="py-2 font-semibold md:px-6 bg-green-600 text-white w-40 rounded-full">
              Get Started
            </div>
            </Link>
            <Link to="/about-mijsc"> <div className="py-1 font-semibold md:px-6 bg-transparent border-2 text-white w-40 rounded-full">
              Learn More
            </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Slider dots */}
      <div className="absolute bottom-4 w-full flex justify-center gap-2">
        {slides.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 rounded-full ${
              index === current ? "bg-white" : "bg-white/50"
            }`}
            onClick={() => {
              setCurrent(index);
              setIsPaused(true); // Pause auto slider when user clicks
            }}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
